import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as permissionsData from 'src/app/models/permissions.json';
import cloneDeep from 'lodash/cloneDeep';

@Component({
    selector: 'app-view-permissions',
    templateUrl: './view-permissions.component.html',
    styleUrls: ['./view-permissions.component.scss'],
    standalone: false
})
export class ViewPermissionsComponent implements OnInit {

  role: any;
  permissionsData: any;
  selectedPermission: any;
  initialPermissionData: any;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any) {}

  ngOnInit(): void {
    this.role = this.data;
    const permissions = permissionsData;
    this.initialPermissionData = permissions.permissionsData;
    this.loadPermissions();
  }

  loadPermissions(): void {
    this.permissionsData = cloneDeep(this.initialPermissionData)
    this.selectedPermission = this.permissionsData.find(item => item?.isSelected === true);
    this.role?.permissions?.forEach(permission =>  {
      const actions = [permission.action];
      if (permission.action.startsWith('/')) {
        actions.push(permission.action.substring(1));
      } else {
        actions.push('/' + permission.action);
      }
      actions.forEach(action => {
      let tab = action.split('/')[1];
      if(action.includes("jumpbox")){
        tab = action.split('/')[2];
      } else if(action.includes("pe-connections")) {
        tab = action.split('/')[2];
      } else if(action.includes("runbook")) {
        tab = action.split('/')[2];
      } else if(action.includes("schedules")) {
        tab = action.split('/')[2];
      } else if(action.includes("jobs")) {
        tab = action.split('/')[2];
      }
      let row;
      if (action.split('/').length === 3 || tab === 'authz') {
        row = action.split('/')[2];
      }
      else {
        row = action.split('/')[2] + '/' + action.split('/')[3];
      }
      if (this.permissionsData.find(item => item.key === tab) && this.permissionsData.find(item => item.key === tab).permissions.find(item => item.key === row) && 
        !this.permissionsData.find(item => item.key === tab)?.permissions.find(item => item.key === row)?.dataZonePermissions) {
        this.permissionsData.find(item => item.key === tab).permissions.find(item => item.key === row).access = true;
      }
      if (this.permissionsData.find(item => item.key === tab)?.permissions.find(item => item.key === row)?.dataZonePermissions) {
        if (permission.attribute === 'datazone') {
          const permissionItem = this.permissionsData.find(item => item.key === tab)?.permissions.find(item => item.key === row)?.dataZonePermissions
          .find(item => item.key === permission.attributeValue);
            if (permissionItem && permissionItem.access !== undefined) {
            permissionItem.access = true;
            }  
        } else if (permission.attribute === 'type') {
          this.permissionsData.find(item => item.key === tab).permissions.find(item => item.key === row)
            .dataZonePermissions.map(item => item.infoDetails = [...item.infoDetails, permission.attributeValue]);
        } else {
          if (tab === 'authz') {
            const permissionItem = this.permissionsData.find(item => item.key === tab)?.permissions.find(item => item.key === row)?.dataZonePermissions
            .find(item => item.key === permission.action.split('/')[3]);
            if (permissionItem && permissionItem.access !== undefined) {
              permissionItem.access = true;
            }  
          }
        }
      }
    });
  })
  }

  dataZonePermissions(permissions): boolean {
    return permissions.some(item => item.dataZonePermissions);
  }

  selectPermission(permission): void {
    this.selectedPermission = permission;
    this.permissionsData.map(item => item.isSelected = false);
    this.permissionsData.find(item => item.key === permission.key).isSelected = true;
  }
}
